import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ImagePreviewData, MediaType } from './image-preview-data';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { genThumbnailUrl, ImageSize, isMediaImage, isMediaInfoPublishable, isMediaVideo } from '@miq/utils';

@Component({
  selector: 'miq-image-preview-dialog',
  templateUrl: './image-preview-dialog.component.html',
  styleUrls: ['./image-preview-dialog.component.scss'],
  standalone: false,
})
export class ImagePreviewDialogComponent implements OnInit, OnDestroy {
  public thumbnailInfo: any[] = [];
  public selectedImage: any;
  MediaType = MediaType;

  constructor(
    public dialogRef: MatDialogRef<ImagePreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: ImagePreviewData
  ) {}

  ngOnInit() {
    this.getImages();
    this.getSelectedImage(this.data.selectedImageId);
  }

  getSelectedImage(id: number) {
    const index = this.thumbnailInfo.findIndex(a => a.id === id);
    this.changeImage(index);
  }

  getImages() {
    this.thumbnailInfo = this.data.imagesMedia.map(media => {
      return {
        imageSrc: genThumbnailUrl(media ? media.media_path : null, { imgSize: ImageSize.Large }),
        publishable: isMediaInfoPublishable(media),
        id: media.id,
        mediaName: media ? media.media_name : null,
        mediaCaption: media ? media.media_caption : null,
        mediaTypeDescription: media ? media.media_type_desc : null,
        mediaType: this.getMediaType(media),
      };
    });
  }

  changeImage(index: number) {
    if (index >= 0 && index < this.thumbnailInfo.length) {
      this.selectedImage = { ...this.thumbnailInfo[index], count: index + 1 };
    }
  }

  getMediaType(media): string {
    if (isMediaImage(media)) {
      return 'image';
    }
    if (isMediaVideo(media)) {
      return 'video';
    }
    return null;
  }

  ngOnDestroy() {
    /* required for static label translation */
  }
}
